import { render, staticRenderFns } from "./PermissionTemplate.vue?vue&type=template&id=5a69773f&"
import script from "./PermissionTemplate.vue?vue&type=script&lang=js&"
export * from "./PermissionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports